import styles from './PromptConfiguration.module.css'
import { AI_AUDIT_MODELS } from '../../../../global/constants/bedrock-models'

interface ModelSelectorProps {
  selectedModel: string
  setSelectedModel: (model: string) => void
  lastSavedModelToLocalStorage: Date | null
  formatTimestamp: (date: Date | null) => string
}

function ModelSelector({
  selectedModel,
  setSelectedModel,
  lastSavedModelToLocalStorage,
  formatTimestamp,
}: ModelSelectorProps) {
  return (
    <div className={styles.modelSelection}>
      <h3 className={styles.sectionLabel}>AI Model</h3>
      <select
        className={styles.modelSelect}
        value={selectedModel}
        onChange={(e) => setSelectedModel(e.target.value)}
      >
        <option value={AI_AUDIT_MODELS.sonnet}>
          Claude Sonnet 4.5 (Best accuracy, higher cost)
        </option>
        <option value={AI_AUDIT_MODELS.haiku}>
          Claude Haiku 4.5 (Faster, lower cost)
        </option>
      </select>
      <div className={styles.autoSaveIndicator}>
        Locally saved: {formatTimestamp(lastSavedModelToLocalStorage)}
      </div>
    </div>
  )
}

export default ModelSelector
